import { BadgeProps } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { StatusPill, type StatusTone } from "../../ui/status-pill"

const TONES: Record<string, StatusTone> = {
  OPEN:        "red",
  IN_PROGRESS: "yellow",
  ESCALATED:   "red",
  RESOLVED:    "green",
  CLOSED:      "gray",
}

interface Props {
  status: string | null | undefined
  /** Kept for call-site compatibility; the status pill has one size. */
  size?: BadgeProps["size"]
}

export function ExceptionStatusBadge({ status }: Props) {
  const { t } = useTranslation("delivery")
  if (!status) return <StatusPill tone="gray">—</StatusPill>
  return <StatusPill tone={TONES[status] ?? "gray"}>{t(`failed.exStatus.${status}`, { defaultValue: status })}</StatusPill>
}
